/**
 * 바이트 값을 사람 친화 단위로 변환. 1024 단위.
 *   1023 → "1023 B"
 *   1024 → "1.0 KB"
 *   1.5 GB → "1.5 GB"
 *   100 GB+ → "100 GB" (소수 생략)
 */
export function formatBytes(bytes: number, fractionDigits = 1): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = bytes / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v >= 100 ? 0 : fractionDigits)} ${units[i]}`;
}
